import { render, staticRenderFns } from "./Combinations.vue?vue&type=template&id=5583281f&"
import script from "./Combinations.vue?vue&type=script&lang=js&"
export * from "./Combinations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports